import React, { Component } from 'react';
import { withRouter } from '../..//withRouter';
import { setCookie } from 'helpers/cookies'
import { connect, } from 'react-redux';
import Form from 'react-bootstrap/Form';
import promotionService from 'services/promotion.service';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

import styles from 'components/Modals/CRMModal/CRMModalStyles.module.scss';
import { pickImage } from "helpers/webpSupport";
import tickImgPng from 'images/Promotions/Blue Tick.png'
import tickImgWebp from 'images/Promotions/Blue Tick.webp'
import envelopeImgPng from 'images/Promotions/Email Guy.png'
import envelopeImgWebp from 'images/Promotions/Email Guy.webp'
import crossPng from 'images/icons/Cross.png'
import crossWebp from 'images/icons/Cross.webp'

const tickImg = pickImage(tickImgWebp, tickImgPng);
const envelopeImg = pickImage(envelopeImgWebp, envelopeImgPng);
const cross = pickImage(crossWebp, crossPng);

// Newsletter sign-up. Only opened on demand from the NavMenu newsletter button - it no longer pops up automatically.
class CRMModal extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    onChangeEmail = (e) => {
        const email = e.target.value;
        this.setState({ email });
    };

    onChangeDOB = (e) => {
        const DOB = e.target.value;
        this.setState({ DOB });
    }

    register = (e) => {
        e.preventDefault();
        setCookie("crm-accepted", true, 400);
        promotionService.submitPromotionEntry(process.env.REACT_APP_NEWSLETTER_PROMO_ID, this.state.email, this.props.pricing.countryCode, this.state.DOB, ["newsletter"]);
        this.props.onClose();
    }

    close = (e) => {
        e.preventDefault();
        this.props.onClose();
    }

    render() {
        return <div className={`${styles.screenOverlay} ${this.props.show && styles.show} ${this.props.styles}`} >
            <div className={styles.screenOverlayBG}></div>
            <div className={styles.modalContainer} >
                <Form onSubmit={this.register} className={styles.modal} >
                    <button className={styles.closeButton} onClick={this.close} >
                        <img src={cross} alt="close-button" />
                    </button>
                    <h2 className={styles.title}>JOIN THE NEWSLETTER</h2>
                    <div className={styles.columbs} >
                        <div className={styles.columb}>
                            <p className={styles.description} >Join the Game.City Newsletter for FREE today and enjoy exclusive game tips, the latest news, and special discounts!</p>
                        </div>
                        <div className={styles.columb}>
                            <div className={styles.calloutWrapper} >
                                <img src={tickImg} className={styles.tick} alt="tick" ></img>
                                <p className={styles.callouts}>EXCLUSIVE OFFERS</p>
                            </div>
                            <div className={styles.calloutWrapper} >
                                <img src={tickImg} className={styles.tick} alt="tick" ></img>
                                <p className={styles.callouts}>COMPETITIONS AND GIVEAWAYS</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.signUp} >
                        <Form.Control className={styles.email} type="email" placeholder="Enter email" required onChange={this.onChangeEmail} />
                        <FloatingLabel controlId="floatingDate" label="Date of birth (optional)">
                            <Form.Control className={styles.email} type="date" placeholder="Enter date of birth (optional)" onChange={this.onChangeDOB} />
                        </FloatingLabel>
                        <div className={styles.buttonWrapper} >
                            <button className={`${styles.button}  ${styles.alternate}`} type="submit" >GIVE ME FREE STUFF</button>
                        </div>
                    </div>
                    <div className={styles.dontShow} >
                        <a className={`${styles.link}`} onClick={this.close} >I DONT LIKE FREE STUFF</a>
                    </div>
                </Form>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        pricing: state.pricing,
    };
}

export default connect(mapStateToProps)(withRouter(CRMModal));
